import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { logout } from '../store/user/actions';
import StatusIndicator from './StatusIndicator';
import { userPermissions } from '../config';

class Sidebar extends Component {
  state = {
      settingsSlideDown: false
  };
 
  toggleSettingsSlideDown = () => {
      this.setState({ settingsSlideDown: !this.state.settingsSlideDown });
  };
  render() {
    let settingsSlideDownClasses = (this.state.settingsSlideDown) ? "active" : "";

    let hTicketsLen = this.props.tickets.highlighted_tickets.length;

    const permissions = this.props.user.permissions;

    const canViewBookings = permissions.includes(userPermissions.viewBookings);
    const canViewCustomers = permissions.includes(userPermissions.viewCustomers);
    const canViewSettings = permissions.includes(userPermissions.viewSettings);
    //const canViewRatings = permissions.includes(userPermissions.viewRatings);
    return (
        <div className="sidebar">
            <div className="sidebar-top">
              <div className="logo">
                <img src="/imgs/gobus-logo.png" alt="Go Bus Logo"/>
              </div>
              <div className="user-data">
                <p className="name">{this.props.user.name}</p>
                <a href="#!" onClick={this.props.logout}>Sign out</a>
              </div>
            </div>
            <div className="sidebar-wrapper">
              <ul className="nav">
                <li>
                  <StatusIndicator />
                </li>
                {/* <li>
                  <NavLink to="/" exact={true}>Dashboard</NavLink>
                </li> */}
                {
                  canViewBookings && (
                    <li>
                      <NavLink to="/bookings">Bookings{
                        hTicketsLen
                          ? <span className="counter">+{hTicketsLen}</span>
                          : null
                      }</NavLink>
                    </li>
                  )
                }
                {
                   /* [RATINGS] [TODO] - check again, add canViewRatings later */
                  <li>
                    <NavLink to="/ratings">Ratings</NavLink>
                  </li>
                  
                }
                {/* <li>
                  <NavLink to="/trips">Trips<span className="counter">+12</span></NavLink>
                </li> */}
                {
                  canViewCustomers && (
                    <li>
                      <NavLink to="/customers">Customers
                        {/* <span className="counter">+12</span> */}
                      </NavLink>
                    </li>
                  )
                }
                {
                  canViewCustomers && (
                    <li>
                      <NavLink to="/customer-exports">Customer Exports
                        {/* <span className="counter">+12</span> */}
                      </NavLink>
                    </li>
                  )
                }
                {/* <li>
                  <a href="#">Reports<span className="counter">+12</span></a>
                </li> */}
                {
                  canViewSettings && (
                    <li className={settingsSlideDownClasses}>
                      <a href="#!" onClick={(event) => { event.preventDefault(); this.toggleSettingsSlideDown() }}>Settings<i className="material-icons">keyboard_arrow_down</i></a>
                      <ul>
                        <li className="sub">
                          <NavLink to="/cities">cities</NavLink>
                        </li>
                        {/* <li className="sub">
                          <a href="#!">SEO</a>
                        </li> */}
                        <li className="sub">
                          <NavLink to="/translation">Translation</NavLink>
                        </li>
                        {/* <li className="sub">
                          <a href="#!">users</a>
                        </li> */}
                        <li className="sub">
                          <NavLink to="/admins">Admins</NavLink>
                        </li>
                      </ul>
                    </li>
                  )
                }
                {/* <li className="foot">
                </li> */}
                <li className="foot">
                  <Link to="/profile" >Profile</Link>
                  <a href="#!" onClick={this.props.logout}>logout</a>
                </li>
              </ul>
            </div>
        </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  tickets: state.tickets 
});

const mapDispatchToProps = dispatch => ({
  logout: bindActionCreators(logout, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);